import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import { AppModule } from '@modules/core/plugins/AppModule';
import {
  MIRRORS_LIST_JS_MAIN_ROUTE_NAME,
  MIRRORS_LIST_NO_JS_MAIN_ROUTE_NAME,
  MIRRORS_LIST_PERMISSIONS,
} from '@modules/mirrors-list/constants';
import {
  MIRRORS_LIST_CREATE_JS_ROUTE_NAME,
  MIRRORS_LIST_CREATE_NO_JS_ROUTE_NAME,
  TRANSLATION_GROUP_MIRRORS_CREATE,
} from '@modules/mirrors-list/submodules/create/constants';
import { MirrorAddFileModule } from '@modules/mirrors-list/submodules/create/submodules/file/MirrorAddFileModule';
import {
  MIRRORS_LIST_CREATE_JS_MANUALLY_ROUTE_NAME,
  MIRRORS_LIST_CREATE_NO_JS_MANUALLY_ROUTE_NAME,
} from '@modules/mirrors-list/submodules/create/submodules/manually/constants';
import {
  MirrorAddManuallyModule,
} from '@modules/mirrors-list/submodules/create/submodules/manually/MirrorAddManuallyModule';
import getTranslationKeys from '@modules/mirrors-list/submodules/create/translations';

export class MirrorsListCreateModule extends AppModule {
  protected submodules = [
    new MirrorAddManuallyModule(),
    new MirrorAddFileModule(),
  ];

  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(MIRRORS_LIST_JS_MAIN_ROUTE_NAME, {
      name: MIRRORS_LIST_CREATE_JS_ROUTE_NAME,
      path: ':mirrorsNamespace/add',
      permission: MIRRORS_LIST_PERMISSIONS.CREATE,
      component: () => import('@modules/mirrors-list/submodules/create/pages/MirrorsListCreatePage/MirrorsListCreatePage.vue'),
      redirect: { name: MIRRORS_LIST_CREATE_JS_MANUALLY_ROUTE_NAME },
    });

    router.addChildRoute(MIRRORS_LIST_NO_JS_MAIN_ROUTE_NAME, {
      name: MIRRORS_LIST_CREATE_NO_JS_ROUTE_NAME,
      path: ':mirrorsNamespace/add',
      permission: MIRRORS_LIST_PERMISSIONS.CREATE,
      component: () => import('@modules/mirrors-list/submodules/create/pages/MirrorsListCreatePage/MirrorsListCreatePage.vue'),
      redirect: { name: MIRRORS_LIST_CREATE_NO_JS_MANUALLY_ROUTE_NAME },
    });
  }

  addMenu(): void {}

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_MIRRORS_CREATE, getTranslationKeys);
  }
}
